import { useState, useCallback } from 'react';

export function useLoadingCounter() {
    const [loadingCount, setLoadingCount] = useState(0);

    const increment = useCallback(() => setLoadingCount((count) => count + 1), []);
    const decrement = useCallback(() => setLoadingCount((count) => Math.max(count - 1, 0)), []);

    const isLoading = loadingCount > 0;

    return { increment, decrement, isLoading };
}
